import { render, staticRenderFns } from "./GlobalAuthModal.vue?vue&type=template&id=36a50ad2&"
import script from "./GlobalAuthModal.vue?vue&type=script&lang=js&"
export * from "./GlobalAuthModal.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAuthModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports